import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { posGateway, PosGatewayManipulationViewModel } from "./posGatewayManipulation-viewModel"

export class PosGatewayManipulationView extends View<PosGatewayManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-C4C36D18-8C49-4234-A419-6BDE591BC83A"
    }
    loadHtml(): string {
        let element = require('./posGatewayManipulation.html').default;
        let style = require('./posGatewayManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set posGateway(v: ObservableArray<posGateway>) { this._posGateway = v; } public get posGateway(): ObservableArray<posGateway> { return this._posGateway;} private _posGateway: ObservableArray<posGateway>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestPosGatewayCreation(){
        this.dataContext.requestPosGatewayCreation();
    }
}
